module.exports = __webpack_public_path__ + "assets/glassfish.b35b826e.svg";